'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentRemoveCircleOutline = function ContentRemoveCircleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ContentRemoveCircleOutline = (0, _pure2.default)(ContentRemoveCircleOutline);
ContentRemoveCircleOutline.displayName = 'ContentRemoveCircleOutline';
ContentRemoveCircleOutline.muiName = 'SvgIcon';

exports.default = ContentRemoveCircleOutline;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/content/remove-circle-outline.js
// module id = 1598
// module chunks = 1